import VueI18n from "vue-i18n";
import traductions from '@/services/traductions.js';
import Vue from "vue";
import moment from "moment";
import {Validator} from "vee-validate";
import axios from "axios";
import {getAppLang, DEFAULT_LANG} from "../services/lang.js";

Vue.use(VueI18n);

let lang = getAppLang();
if (!traductions[lang]) {
  lang = DEFAULT_LANG;
}

let messages = {};
messages[lang] = {...traductions[lang]};

export function setI18nLang(lang) {
  i18n.locale = lang;
  moment.locale(lang);
  if (Validator && Validator.setLocale) Validator.setLocale(lang);
  axios.defaults.headers['Accept-Language'] = lang;
}

export const i18n = new VueI18n({
  locale: lang,
  fallback: 'fr',
  messages
})



// WEBPACK FOOTER //
// ./src/setup/i18n-setup.js